import { render, staticRenderFns } from "./virtualTable.vue?vue&type=template&id=363b9d4e&scoped=true"
import script from "./virtualTable.vue?vue&type=script&lang=js"
export * from "./virtualTable.vue?vue&type=script&lang=js"
import style0 from "./virtualTable.vue?vue&type=style&index=0&id=363b9d4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363b9d4e",
  null
  
)

export default component.exports